let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Hsfj")).then(() => parcelRequire('fs9xr'));